import KeyValueTextInputField from './KeyValueTextInputField';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';
import AddMoreButton from '../inputs/AddMoreButton';
import { generateImagePath } from '../../../../helpers/helpers';

export default function DetailsSection({
  investmentData,
  handleInputChange,
  handleAddItem,
  handleObjectArrayInputChange,
  removeItemFromArray,
  dispatch,
}) {
  const detailsSectionTitle = {
    label: 'Details Title',
    value: investmentData.en.detailsSection.title,
    section: 'detailsSection',
    field: 'title',
    config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
  };

  const detailsSectionParagraphsFields =
    investmentData.en.detailsSection.paragraphs.map((paragraphs, index) => ({
      label: `Paragraphs Key ${index + 1}`,
      value: paragraphs,
      section: 'detailsSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.textarea] },
    }));

  const detailsSectionPlanFields = investmentData.en.detailsSection.plan.map(
    (plan, index) => ({
      label: `Plan Key ${index + 1}`,
      key1: 'key',
      key2: 'value',
      value1: plan.key,
      value2: plan.value,
      section: 'detailsSection',
      field: 'plan',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.textarea] },
    }),
  );

  const detailsSectionTitleAr = {
    label: 'عنوان التفاصيل',
    value: investmentData.ar.detailsSection.title,
    section: 'detailsSection',
    field: 'title',
    config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
  };

  const detailsSectionParagraphsFieldsAr =
    investmentData.ar.detailsSection.paragraphs.map((paragraphs, index) => ({
      label: `فقرة ${index + 1}`,
      value: paragraphs,
      section: 'detailsSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.textarea] },
    }));

  const detailsSectionPlanFieldsAr = investmentData.ar.detailsSection.plan.map(
    (plan, index) => ({
      label: `خطة ${index + 1}`,
      key1: 'key',
      key2: 'value',
      value1: plan.key,
      value2: plan.value,
      section: 'detailsSection',
      field: 'plan',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.textarea] },
    }),
  );

  return (
    <section className="mb-5">
      <h3 className="mb-3">Property Details</h3>
      <img
        src={generateImagePath('details-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        {/* English Fields */}
        <div className="col-md-6">
          <FieldTypeSelector
            label={detailsSectionTitle.label}
            fieldName={detailsSectionTitle.field}
            value={detailsSectionTitle.value}
            config={detailsSectionTitle.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: detailsSectionTitle.section,
                field: detailsSectionTitle.field,
                lang: 'en',
              })
            }
          />
        </div>
        <div className="col-md-6" dir="rtl">
          <FieldTypeSelector
            label={detailsSectionTitleAr.label}
            fieldName={detailsSectionTitleAr.field}
            value={detailsSectionTitleAr.value}
            config={detailsSectionTitleAr.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                section: detailsSectionTitleAr.section,
                field: detailsSectionTitleAr.field,
                lang: 'ar',
              })
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h4 className="mt-4 mb-3">Details Plan</h4>
          {detailsSectionPlanFields.map((field, index) => (
            <KeyValueTextInputField
              key={index}
              label={field.label}
              fieldName1="key"
              fieldName2="values"
              value1={field.value1}
              value2={field.value2}
              lang="en"
              onInputChange1={(e) =>
                handleObjectArrayInputChange(
                  e,
                  field.section,
                  field.field,
                  field.index,
                  field.key1,
                  'en',
                )
              }
              onInputChange2={(e) =>
                handleObjectArrayInputChange(
                  e,
                  field.section,
                  field.field,
                  field.index,
                  field.key2,
                  'en',
                )
              }
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>

        <div className="col-md-6" dir="rtl">
          <h4 className="mt-4 mb-3">تفاصيل الخطة</h4>
          {detailsSectionPlanFieldsAr.map((field, index) => (
            <KeyValueTextInputField
              key={index}
              label={field.label}
              fieldName1="key"
              fieldName2="values"
              value1={field.value1}
              value2={field.value2}
              lang="ar"
              onInputChange1={(e) =>
                handleObjectArrayInputChange(
                  e,
                  field.section,
                  field.field,
                  field.index,
                  field.key1,
                  'ar',
                )
              }
              onInputChange2={(e) =>
                handleObjectArrayInputChange(
                  e,
                  field.section,
                  field.field,
                  field.index,
                  field.key2,
                  'ar',
                )
              }
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
        <AddMoreButton
          handleAddItem={() =>
            handleAddItem('detailsSection', 'plan', { key: '', value: [] })
          }
        />
      </div>

      <div className="row">
        <div className="col-md-6">
          <h4 className="mt-4 mb-3">Details Paragraphs</h4>
          {detailsSectionParagraphsFields.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  index: field.index,
                })
              }
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
        <div className="col-md-6" dir="rtl">
          <h4 className="mt-4 mb-3">تفاصيل الفقرات</h4>
          {detailsSectionParagraphsFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
        <AddMoreButton
          handleAddItem={() => handleAddItem('detailsSection', 'paragraphs')}
        />
      </div>
    </section>
  );
}
